module.exports = __webpack_public_path__ + "img/motor_no56.1bc55203.jpg";